import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }
    api.session(sessionId)
      .then(async (user) => {
        // Clean fragment
        window.history.replaceState(null, "", window.location.pathname);
        // Apply pending referral if any
        try {
          const ref = localStorage.getItem("pending_referral");
          if (ref) {
            await api.referralsApply(ref).catch(() => {});
            localStorage.removeItem("pending_referral");
          }
        } catch (e) { /* noop */ }
        navigate("/game", { state: { user } });
      })
      .catch(() => navigate("/login"));
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center text-[#8c8c8c] font-heading tracking-widest">
      <span className="ember-pulse">CROSSING THE THRESHOLD...</span>
    </div>
  );
}
